import script from "./FileBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FileBox.vue?vue&type=script&setup=true&lang=js"

import "./FileBox.vue?vue&type=style&index=0&id=3d90037a&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d90037a"]])

export default __exports__